/**
 * Whether the "Admin & dev" nav section has anything in it.
 *
 * The header renders only when this is true, so every item placed under it has to be
 * accounted for here. Miss one and it renders with no heading above it, reading as part of
 * the preceding section — which is what happened when IVR Configuration moved down into
 * this section while keeping its own independent condition.
 */
export function hasAdminDevSectionItems(options: {
  isDevMode: boolean;
  isAdminUser: boolean;
  canSeeIvrConfig: boolean;
}): boolean {
  return options.isDevMode || options.isAdminUser || options.canSeeIvrConfig;
}

/**
 * Whether the "Patient access" nav section has anything in it.
 *
 * Same contract as the Admin & dev header above: every item placed under this
 * heading has to be accounted for here, or the heading renders empty and reads as
 * a label on the section that follows it.
 *
 * Currently the PAC manager dashboard alone. The design also groups a Call queue
 * here, which does not exist in Orbit yet.
 */
export function hasPatientAccessSectionItems(options: { canSeeCiManagerDashboard: boolean }): boolean {
  return options.canSeeCiManagerDashboard;
}

/**
 * Whether the "Finance" nav section has anything in it. Same contract as above.
 *
 * Currently the Finance ops page alone (BAR-3024).
 */
export function hasFinanceSectionItems(options: { canSeeFinanceOps: boolean }): boolean {
  return options.canSeeFinanceOps;
}
